import React from 'react';
import Shimmer from 'sushiweb/Shimmer';

export const SkeletonBlock = ({ height, className }) => (
  <div className={`tw-rounded-lg tw-overflow-hidden tw-flex-1 ${className}`}>
    <Shimmer height={height} width='100%' />
  </div>
);
